<template>
  <div>
    <Header>Route Detail</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mx-auto my-4">
        <div class="flex flex-col items-center gap-4"
          v-if="routeId === undefined">
          <span>
            Please select an item in Route List
          </span>
          <Button
            class="w-1/3"
            color="gray"
            size="md"
            @click="toRouteList()">
            Route List
          </Button>
        </div>
        <div
          v-show="routeId !== undefined">
          <div class="grid grid-cols-3 gap-7 pb-2">
            <CalendarField
              class="pt-1.5"
              v-model="routeDate"
            >
              Date
            </CalendarField>
          </div>
          <RouteDetail
            :key="mapComponentKey"
            :routeId="routeId"
            :date="routeDate"
            :title="title"
            :showRouteTimes="showRouteTimes"
          />
        </div>
      </div>
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Main from '../components/Main.vue'
import Header from '../components/Header.vue'
import Button from '../components/Button.vue'
import CalendarField from '../components/formComponents/CalendarField.vue'
import RouteDetail from '../components/RouteDetail.vue'

export default {
  components: {
    Main,
    Header,
    Button,
    CalendarField,
    RouteDetail,
  },
  data() {
    return {
      mapComponentKey: 0,
      routeId: undefined,
      routeDate: undefined,
      title: undefined,
      showRouteTimes: false,
    }
  },
  methods: {
    reloadRouteDetail() {
      this.mapComponentKey = !this.mapComponentKey
    },
    toRouteList() {
      this.$router.push({
        name: 'RouteList'
      })
    },
  },
  mounted() {
    this.routeId = this.$route.params.id
    if (!this.routeId) {
      this.routeId = this.$route.query.routeId
    }
    this.showRouteTimes = this.$route.params.showRouteTimes
    this.routeDate = this.$route.query.date
    this.title = this.$route.query.title
    console.log('mounted', this.routeId)
    console.log('mounted', this.date)
  },
  // created() {
  //   this.routeId = this.$route.params.id
  //   if (!this.routeId) {
  //     this.routeId = this.$route.query.routeId
  //   }
  //   this.routeDate = this.$route.query.date
  //   this.title = this.$route.query.title
  //   console.log('created', this.routeId)
  //   console.log('created', this.date)
  // },
  watch: {
    '$router.params.id': function (newValue) {
      this.routeId = newValue
    },
    '$router.query': function () {
      console.log('$router.query WATCH')
      var reloadMap = false
      if (this.routeId !== this.$route.query.routeId) {
        this.routeId = this.$route.query.routeId
        reloadMap = true
      }

      if (this.routeDate !== this.$route.query.date) {
        this.routeDate = this.$route.query.date
        reloadMap = true
      }

      if (this.title !== this.$route.query.title) {
        this.title = this.$route.query.title
      }

      if (reloadMap) {
        this.reloadRouteDetail()
      }
    },
    routeDate: function(newValue) {
      if (this.routeDate !== this.$route.query.date) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            date: newValue
          }
        })
      }
    },
  },
}
</script>
